module.exports = __webpack_public_path__ + "static/media/Check_thick.4fa582fd.svg";